import { httpClient, type Cursor } from '#shared'
import { type ChatType } from '#entities/chat'
import { type GetChatsResponse } from '../model/get-chats-response'

interface GetChatsOptions {
  count?: number
  after?: Cursor
}

export async function getChats(type: ChatType, { count = 20, after }: GetChatsOptions = {}) {
  const searchParams = new URLSearchParams([
    ['count', count.toString()],
    ['type', type],
  ])

  if (after) searchParams.set('after', after.toString())

  const requestUrl = `chats?${searchParams.toString()}`

  const response = await httpClient.get<GetChatsResponse>(requestUrl, { requireAuth: type === 'personal' })
  const responseBody = await response.json()

  return responseBody
}
